import { render, staticRenderFns } from "./SetStoreTable.vue?vue&type=template&id=2b7f19b3&scoped=true"
import script from "./SetStoreTable.vue?vue&type=script&lang=js"
export * from "./SetStoreTable.vue?vue&type=script&lang=js"
import style0 from "./SetStoreTable.vue?vue&type=style&index=0&id=2b7f19b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7f19b3",
  null
  
)

export default component.exports